'use strict';
(()=>{
  const root=document.getElementById('fundidores-review');
  root.querySelectorAll('[data-mc-target]').forEach(button=>{
    button.addEventListener('click',()=>{
      const target=root.querySelector('#'+button.getAttribute('data-mc-target'));
      if(target)target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });
  });
  const pair=root.querySelector('#fu-product-pair');
  const options={normal:'Miel Normal',sensible:'Miel Sensible',cremosa:'Miel Cremosa',caliente:'pocillo de Cera Caliente'};
  root.querySelectorAll('[data-fu-product]').forEach(button=>{
    button.addEventListener('click',()=>{
      const key=button.getAttribute('data-fu-product');
      if(!Object.hasOwn(options,key))return;
      const name=options[key],hot=key==='caliente';
      for(const model of ['universal','mini']){
        const photo=root.querySelector('#fu-'+model+'-loaded');
        const honey=root.querySelector('[data-fu-honey="'+model+'"]');
      const original=root.querySelector('[data-fu-normal="'+model+'"]');
        const size=model==='universal'?'600 g':'300 g';
      photo.hidden=!hot;honey.hidden=hot||key==='normal';original.hidden=key!=='normal';
        root.querySelector('[data-fu-pocillo-status="'+model+'"]').hidden=!hot;
      if(!hot&&key!=='normal'){
          const can=honey.querySelector('[data-heater-can]');
          const sensible=key==='sensible';
          can.setAttribute('href',window.MundoCargoletConfig.assets['assets/'+(sensible?'mc-2026-sensible-':'mc-manual-foto--cremosa-')+size.replace(' ','')+'.webp']);
          can.setAttribute('height',model==='universal'?(sensible?'131.5747':'116.1593'):(sensible?'114.7274':'95.03'));
          honey.querySelector('svg').setAttribute('aria-label','Fundidor '+model+' con '+name+' de '+size);
        }
        photo.width=360;photo.height=300;
      root.querySelector('#fu-'+model+'-caption').textContent=key==='normal'?'Con Miel Normal · fotografía 2026':hot?'Con pocillo · vista frontal':'Con '+name+' de '+size+' · vista frontal';
      }
      pair.classList.toggle('mc-show-pocillo',hot);
    root.querySelector('#fu-gallery-note').textContent=key==='normal'?'Miel Normal en los fundidores Universal y Mini. Fotografías de las presentaciones 2026.':hot?'El pocillo reutilizable Cargolet cabe en los dos fundidores. El pocillo llegará próximamente y se adquirirá por separado.':name+': 600 g en el Universal y 300 g en el Mini. Los cuerpos se muestran a la misma altura.';
      root.querySelectorAll('[data-fu-product]').forEach(control=>control.setAttribute('aria-pressed',String(control===button)));
    });
  });
})();
